import '/assets/styles/sections/header.scss';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import config from '@wearetla/tla-essentials-tools/config';

// Partials
import Btn from '/views/partials/btn'
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Static Assets
import image_logo from '/assets/images/logo.svg';

export const Header = () => {
	const [fixed, setFixed] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setFixed(window.scrollY > 10);
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<>
			<header className={classNames('section header', { fixed })}>
				<div className="header-wrap wrapper">
					<div className="header-logo">
						<a
							href="#hero"
							className="logo-imagewrap">
							<Img
								alt={config.brandInfo?.name}
								src={image_logo}
								lazy={false}
								className="logo-image" />
						</a>
					</div>

					<nav className="header-nav">
						<a href="#incy-pay">Incy Pay</a>
						<a href="#incy-ticket">Incy Ticket</a>
						<a href="#incy-restaurant">Incy Restaurant</a>
						<a href="#incy-screen">Incy Screen</a>
						<a href="#contact">Contact</a>
					</nav>

					<Btn
						tag="a"
						href="#contact"
						className="header-contactcta secondary">
						Get Started
					</Btn>
				</div>
			</header>
			<div id="header-placeholder" className="section header-placeholder" />
		</>
	)
}

export default Header;